module.exports = __webpack_public_path__ + "media/images/layouts/sprite-01c8b4b3458e25107214ee76ce17b3cc.svg";